import request from '../../utils/requests'

/**
 * Tag: Customer
 */

const baseUrl = '/api/Customer';

/**
 * 匿名：新增
 * @param {*} body
 * {
 *    CustomerId Desc:主键 Required:false
 *    Name Desc:姓名 Required:true
 *    Phone Desc:手机号 Required:true
 *    ImgUrl Desc:头像 Required:false
 *    IntentCourseId Desc:意向课程ID Required:false
 *    EntryChannel Desc:录入渠道:0:其他，1：小程序 Required:false
 *    CustomerStatus Desc:跟进状态:1.待跟进，2.跟进中，3.待体验,4.已体验,5.已成交,6.已流失 Required:false
 *    Operator Desc:经办人(创建新用户的时候传OrgUserID) Required:false
 *    OperateTime Desc:经办时间 Required:false
 *    BranchId Desc:校区ID Required:false
 *    OrgId Desc:机构ID（后台使用，匿名方法时需要传） Required:false
 *    FollowUpUserIdList Desc:跟进人IdList Required:false
 *    CustomerTagList Desc:客户标签List，存ID Required:false
 *    IsCommonSea Desc:是否为公海客户（1：是公海客户，0：非公海客户） Required:false
 *    Timestamp Desc:是否为高意向度，1：高意向，0：低意向 Required:false
 *    Source Desc:来源:枚举：1.朋友介绍2.微信3.广告4.其他 Required:false
 *    Sex Desc:性别 1.男 2.女 0.未知 Required:false
 *    ContactPerson Desc:紧急联系人(家长电话) Required:false
 *    IdCard Desc:身份证 Required:false
 *    Birthday Desc:生日 Required:false
 *    Guardian Desc:监护人 Required:false
 *    Address Desc:地址 Required:false
 *    Promoter Desc:推荐人 Required:false
 *    QQ Desc:QQ Required:false
 *    WeChat Desc:微信 Required:false
 *    School Desc:学校 Required:false
 *    Remark Desc:备注说明 Required:false
 *    SignDate Desc:报名日期 Required:false
 *    SignNumber Desc:报名编号 Required:false
 *    GroupIdentify Desc:学员组别 Required:false
 *    Speciality Desc:特长 Required:false
 *    IsResidence Desc:是否住校 Required:false
 *    GraduateSchool Desc:毕业学校 Required:false
 *    Class Desc:在读班级 Required:false
 *    GuardianIdCard Desc:家长/监护人身份证号 Required:false
 * }
 */
async function _addForAnonymous (body) {
  return request(baseUrl + '/addForAnonymous', {
    method: 'POST',
    body: body
  });
}

/**
 * 新增
 * @param {*} body
 * {
 *    CustomerId Desc:主键 Required:false
 *    Name Desc:姓名 Required:true
 *    Phone Desc:手机号 Required:true
 *    ImgUrl Desc:头像 Required:false
 *    IntentCourseId Desc:意向课程ID Required:false
 *    EntryChannel Desc:录入渠道:0:其他，1：小程序 Required:false
 *    CustomerStatus Desc:跟进状态:1.待跟进，2.跟进中，3.待体验,4.已体验,5.已成交,6.已流失 Required:false
 *    Operator Desc:经办人(创建新用户的时候传OrgUserID) Required:false
 *    OperateTime Desc:经办时间 Required:false
 *    BranchId Desc:校区ID Required:false
 *    OrgId Desc:机构ID（后台使用，匿名方法时需要传） Required:false
 *    FollowUpUserIdList Desc:跟进人IdList Required:false
 *    CustomerTagList Desc:客户标签List，存ID Required:false
 *    IsCommonSea Desc:是否为公海客户（1：是公海客户，0：非公海客户） Required:false
 *    Timestamp Desc:是否为高意向度，1：高意向，0：低意向 Required:false
 *    Source Desc:来源:枚举：1.朋友介绍2.微信3.广告4.其他 Required:false
 *    Sex Desc:性别 1.男 2.女 0.未知 Required:false
 *    ContactPerson Desc:紧急联系人(家长电话) Required:false
 *    IdCard Desc:身份证 Required:false
 *    Birthday Desc:生日 Required:false
 *    Guardian Desc:监护人 Required:false
 *    Address Desc:地址 Required:false
 *    Promoter Desc:推荐人 Required:false
 *    QQ Desc:QQ Required:false
 *    WeChat Desc:微信 Required:false
 *    School Desc:学校 Required:false
 *    Remark Desc:备注说明 Required:false
 *    SignDate Desc:报名日期 Required:false
 *    SignNumber Desc:报名编号 Required:false
 *    GroupIdentify Desc:学员组别 Required:false
 *    Speciality Desc:特长 Required:false
 *    IsResidence Desc:是否住校 Required:false
 *    GraduateSchool Desc:毕业学校 Required:false
 *    Class Desc:在读班级 Required:false
 *    GuardianIdCard Desc:家长/监护人身份证号 Required:false
 * }
 */
async function _add (body) {
  return request(baseUrl + '/add', {
    method: 'POST',
    body: body
  });
}

/**
 * 更新
 * @param {*} body
 * {
 *    CustomerId Desc:主键 Required:false
 *    Name Desc:姓名 Required:true
 *    Phone Desc:手机号 Required:true
 *    ImgUrl Desc:头像 Required:false
 *    IntentCourseId Desc:意向课程ID Required:false
 *    EntryChannel Desc:录入渠道:0:其他，1：小程序 Required:false
 *    CustomerStatus Desc:跟进状态:1.待跟进，2.跟进中，3.待体验,4.已体验,5.已成交,6.已流失 Required:false
 *    Operator Desc:经办人(创建新用户的时候传OrgUserID) Required:false
 *    OperateTime Desc:经办时间 Required:false
 *    BranchId Desc:校区ID Required:false
 *    OrgId Desc:机构ID（后台使用，匿名方法时需要传） Required:false
 *    FollowUpUserIdList Desc:跟进人IdList Required:false
 *    CustomerTagList Desc:客户标签List，存ID Required:false
 *    IsCommonSea Desc:是否为公海客户（1：是公海客户，0：非公海客户） Required:false
 *    Timestamp Desc:是否为高意向度，1：高意向，0：低意向 Required:false
 *    Source Desc:来源:枚举：1.朋友介绍2.微信3.广告4.其他 Required:false
 *    Sex Desc:性别 1.男 2.女 0.未知 Required:false
 *    ContactPerson Desc:紧急联系人(家长电话) Required:false
 *    IdCard Desc:身份证 Required:false
 *    Birthday Desc:生日 Required:false
 *    Guardian Desc:监护人 Required:false
 *    Address Desc:地址 Required:false
 *    Promoter Desc:推荐人 Required:false
 *    QQ Desc:QQ Required:false
 *    WeChat Desc:微信 Required:false
 *    School Desc:学校 Required:false
 *    Remark Desc:备注说明 Required:false
 *    SignDate Desc:报名日期 Required:false
 *    SignNumber Desc:报名编号 Required:false
 *    GroupIdentify Desc:学员组别 Required:false
 *    Speciality Desc:特长 Required:false
 *    IsResidence Desc:是否住校 Required:false
 *    GraduateSchool Desc:毕业学校 Required:false
 *    Class Desc:在读班级 Required:false
 *    GuardianIdCard Desc:家长/监护人身份证号 Required:false
 * }
 */
async function _update (body) {
  return request(baseUrl + '/update', {
    method: 'POST',
    body: body
  });
}

/**
 * 机构删除单条数据
 * @param {*} param
 * {
 *    customerId Desc:客户ID Required:true
 *    branchId Desc:校区ID Required:true
 * }
 */
async function _delete (param) {
  return request(baseUrl + '/delete', {
    method: 'GET',
    params: param
  });
}

/**
 * 校区删除单条数据
 * @param {*} param
 * {
 *    customerId Desc:客户ID Required:true
 *    branchId Desc:校区ID Required:true
 * }
 */
async function _deleteForBranch (param) {
  return request(baseUrl + '/deleteForBranch', {
    method: 'GET',
    params: param
  });
}

/**
 * 机构批量删除
 * @param {*} body
 * {
 *    IdList Desc:IDList Required:false
 *    BranchId Desc:校区ID,校区时填当前校区,机构时填《=0即可 Required:false
 *    CourseIdList Desc:课程Id列表（获取课程班级列表时传，其他不需要传） Required:false
 *    EnrolmentStatus Desc:招生状态枚举 EEnrolmentStatus -1全部 1开放 2停止 Required:false
 * }
 */
async function _batchDelete (body) {
  return request(baseUrl + '/batchDelete', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区批量删除
 * @param {*} body
 * {
 *    IdList Desc:IDList Required:false
 *    BranchId Desc:校区ID,校区时填当前校区,机构时填《=0即可 Required:false
 *    CourseIdList Desc:课程Id列表（获取课程班级列表时传，其他不需要传） Required:false
 *    EnrolmentStatus Desc:招生状态枚举 EEnrolmentStatus -1全部 1开放 2停止 Required:false
 * }
 */
async function _batchDeleteForBranch (body) {
  return request(baseUrl + '/batchDeleteForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 获取单个Model
 * @param {*} body
 * {
 *    CustomerId Desc:主键 Required:false
 *    OrgId Desc:机构ID（后台使用） Required:false
 *    Name Desc:姓名 Required:false
 *    Phone Desc:手机号 Required:false
 * }
 */
async function _getModel (body) {
  return request(baseUrl + '/getModel', {
    method: 'POST',
    body: body
  });
}

/**
 * 获取客户编辑Model
 * @param {*} body
 * {
 *    CustomerId Desc:主键 Required:false
 *    OrgId Desc:机构ID（后台使用） Required:false
 *    Name Desc:姓名 Required:false
 *    Phone Desc:手机号 Required:false
 * }
 */
async function _getEditModel (body) {
  return request(baseUrl + '/getEditModel', {
    method: 'POST',
    body: body
  });
}

/**
 * 报名获取跟进人Id
 * @param {*} body
 * {
 *    CustomerId Desc:主键 Required:false
 *    OrgId Desc:机构ID（后台使用） Required:false
 *    Name Desc:姓名 Required:false
 *    Phone Desc:手机号 Required:false
 * }
 */
async function _getExistFollowUpId (body) {
  return request(baseUrl + '/getExistFollowUpId', {
    method: 'POST',
    body: body
  });
}

/**
 * 分页查询
 * @param {*} body
 * {
 *    NameOrPhone Desc:姓名/手机号 Required:false
 *    Sex Desc:性别 Required:false
 *    Birthday Desc:生日开始 Required:false
 *    BirthdayEnd Desc:生日结束 Required:false
 *    IntentCourseIdList Desc:意向课程ID Required:false
 *    BranchIdList Desc:意向校区ID Required:false
 *    IntentCourseName Desc:意向课程名称 Required:false
 *    CustomerStatus Desc:跟进状态:1.待跟进，2.跟进中，3.待体验,4.已体验,5.已成交,6.已流失 Required:false
 *    EntryChannel Desc:录入渠道：1 前台录入 2 教练端录入 3 批量导入 4 扫码录入

          5 砍价录入  6 卡券录入 7 老带新录入 8 体验课录入 9 精品课预约录入 Required:false
 *    EntryChannelDetail Desc:渠道为：1,2,3,4时,查询的机构人员的姓名，

渠道为：5 查询的是活动Id，

渠道为：6查询的是卡券Id,

渠道为：7查询的是老带新Id,

渠道为：8的查询的体验课Id

渠道为：9的查询的精品课程Id

5,6,7,8，9 默认参数为0时，跳过此查询字段

二级渠道对照

前台：经办人

教练端：经办人

批量：经办人

扫码：经办人

砍价：活动名称

卡券：卡券名称

老带新：学员名称

体验课：体验课名称

精品课程：精品课程名称 Required:false
 *    FollowUpUserName Desc:跟进人名字 Required:false
 *    FollowUpUserId Desc:当前跟进人Id(登录人ID,我的客户时使用） Required:false
 *    CustomerTagId Desc:客户标签 Required:false
 *    CreateUserId Desc:经办人 Required:false
 *    IsCommonSea Desc:是否为公海客户（1：是公海客户，0：非公海客户，-1:全部） Required:false
 *    BranchId Desc:校区 Required:false
 *    IsStar Desc:是否为星标客户,默认查全部（1:是，0:否,-1 全部） Required:false
 *    RecordStartDate Desc:跟进记录日期-开始 Required:false
 *    RecordEndDate Desc:跟进记录日期-结束 Required:false
 *    OperateStartDate Desc:经办（录入）时间-开始 Required:false
 *    OperateEndDate Desc:经办（录入）时间-结束 Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _paging (body) {
  return request(baseUrl + '/paging', {
    method: 'POST',
    body: body
  });
}

/**
 * 设置客户的跟进状态
 * @param {*} param
 * {
 *    customerId Desc:客户ID Required:true
 *    customerStatus Desc:客户跟进状态:1.待跟进，2.跟进中，3.待体验,4.已体验,5.已成交,6.已流失 Required:true
 * }
 */
async function _setCustomerStatus (param) {
  return request(baseUrl + '/setCustomerStatus', {
    method: 'GET',
    params: param
  });
}

/**
 * 设置/取消 置顶
 * @param {*} body
 * {
 *    ID Desc:主键ID值 Required:true
 *    IsSetTop Desc:置顶状态 0：取消置顶，1：设置置顶 Required:true
 * }
 */
async function _setOrCancelTop (body) {
  return request(baseUrl + '/setOrCancelTop', {
    method: 'POST',
    body: body
  });
}

/**
 * 退回公海/客户
 * @param {*} param
 * {
 *    customerId Desc:客户ID Required:true
 *    orgUserId Desc:跟进人ID,(退回客户时：当前跟进人ID,退回公海：不填或0) Required:false
 * }
 */
async function _returnCommonSea (param) {
  return request(baseUrl + '/returnCommonSea', {
    method: 'POST',
    params: param
  });
}

/**
 * 根据配置退回公海客户
 */
async function _autoReturnCommonSea () {
  return request(baseUrl + '/autoReturnCommonSea', {
    method: 'GET'
  });
}

/**
 * 为公海客户批量添加跟进人
 * @param {*} body
 * {
 *    CustomerIdList Desc:客户ID Required:false
 *    OrgUserIdList Desc:跟进人ID Required:false
 *    OrgId Desc:机构ID Required:false
 *    BranchId Desc:校区ID Required:false
 * }
 */
async function _batchAddOrgUser (body) {
  return request(baseUrl + '/batchAddOrgUser', {
    method: 'POST',
    body: body
  });
}

/**
 * 获取我的销售漏斗(精确到日期)
 * @param {*} param
 * {
 *    branchId Desc:校区ID Required:true
 *    startDate Desc:开始日期 Required:true
 *    endDate Desc:结束日期 Required:true
 * }
 */
async function _getMySalesFunnel (param) {
  return request(baseUrl + '/getMySalesFunnel', {
    method: 'GET',
    params: param
  });
}

/**
 * 给客户单独设置客户标签（先删后插）
 * @param {*} param
 * {
 *    req.branchIdList Desc:校区 Required:false
 *    req.customerTagIdList Desc:客户标签 Required:false
 *    req.customerIdList Desc:客户 Required:false
 * }
 */
async function _saveCustomerTag (param) {
  return request(baseUrl + '/saveCustomerTag', {
    method: 'GET',
    params: param
  });
}

/**
 * 导入客户
 */
async function _impExp () {
  return request(baseUrl + '/impExp', {
    method: 'POST'
  });
}

/**
 * 导出数据
 * @param {*} body
 * {
 *    NameOrPhone Desc:姓名/手机号 Required:false
 *    Sex Desc:性别 Required:false
 *    Birthday Desc:生日开始 Required:false
 *    BirthdayEnd Desc:生日结束 Required:false
 *    IntentCourseIdList Desc:意向课程ID Required:false
 *    BranchIdList Desc:意向校区ID Required:false
 *    IntentCourseName Desc:意向课程名称 Required:false
 *    CustomerStatus Desc:跟进状态:1.待跟进，2.跟进中，3.待体验,4.已体验,5.已成交,6.已流失 Required:false
 *    EntryChannel Desc:录入渠道：1 前台录入 2 教练端录入 3 批量导入 4 扫码录入

          5 砍价录入  6 卡券录入 7 老带新录入 8 体验课录入 9 精品课预约录入 Required:false
 *    EntryChannelDetail Desc:渠道为：1,2,3,4时,查询的机构人员的姓名，

渠道为：5 查询的是活动Id，

渠道为：6查询的是卡券Id,

渠道为：7查询的是老带新Id,

渠道为：8的查询的体验课Id

渠道为：9的查询的精品课程Id

5,6,7,8，9 默认参数为0时，跳过此查询字段

二级渠道对照

前台：经办人

教练端：经办人

批量：经办人

扫码：经办人

砍价：活动名称

卡券：卡券名称

老带新：学员名称

体验课：体验课名称

精品课程：精品课程名称 Required:false
 *    FollowUpUserName Desc:跟进人名字 Required:false
 *    FollowUpUserId Desc:当前跟进人Id(登录人ID,我的客户时使用） Required:false
 *    CustomerTagId Desc:客户标签 Required:false
 *    CreateUserId Desc:经办人 Required:false
 *    IsCommonSea Desc:是否为公海客户（1：是公海客户，0：非公海客户，-1:全部） Required:false
 *    BranchId Desc:校区 Required:false
 *    IsStar Desc:是否为星标客户,默认查全部（1:是，0:否,-1 全部） Required:false
 *    RecordStartDate Desc:跟进记录日期-开始 Required:false
 *    RecordEndDate Desc:跟进记录日期-结束 Required:false
 *    OperateStartDate Desc:经办（录入）时间-开始 Required:false
 *    OperateEndDate Desc:经办（录入）时间-结束 Required:false
 *    OrgId Desc:机构ID(后台使用) Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _expExcel (body) {
  return request(baseUrl + '/expExcel', {
    method: 'POST',
    body: body
  });
}
async function _checkCustomerByPhone (param) {
  return request(baseUrl + '/CheckCustomerByPhone', {
    method: 'GET',
    params: param
  });
}
export default{
  _addForAnonymous,
  _add,
  _update,
  _delete,
  _deleteForBranch,
  _batchDelete,
  _batchDeleteForBranch,
  _getModel,
  _getEditModel,
  _getExistFollowUpId,
  _paging,
  _setCustomerStatus,
  _setOrCancelTop,
  _returnCommonSea,
  _autoReturnCommonSea,
  _batchAddOrgUser,
  _getMySalesFunnel,
  _saveCustomerTag,
  _impExp,
  _expExcel,
  _checkCustomerByPhone
}



// WEBPACK FOOTER //
// ./src/services/customer.js